/* global liveagent */
// eslint-disable-next-line
import { h, Component } from 'preact';
import classNames from 'classnames';
import Portal from 'preact-portal';
import ClipboardJS from 'clipboard';
import axios from 'axios';

import TopPositionBar from './components/notificationBar';
import IconCopy from './icon-copy';
import {
    DEFAULT_SITE_ID,
    COPY_LINK_DISABLED_PAGES,
    API_COPY_LINK_CONFIG_URL,
    COPY_LINK_BTN,
    CSC_ID,
    SDL_HEADER_DESKTOP_INCREASED,
    SDL_HEADER_DESKTOP_REDUCED,
    SDL_HEADER_MOBILE,
} from '../../../consts';
import isDesktop from '../../../utils/isDesktop';

import styles from './index.scss';

function isBtnEnabledForPage() {
    return !COPY_LINK_DISABLED_PAGES.find(urlRx => !!window.location.pathname.match(urlRx));
}

class CopyLinkButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDesktop: isDesktop(),
            showTopBar: false,
            stickyAreaHeight: null,
            btnEnabled: isBtnEnabledForPage(),
            isLinkUpdated: false,
            config: {},
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.setTopPositionBarRef = this.setTopPositionBarRef.bind(this);
    }

    handleCloseTopBar = () => {
        this.setState({ showTopBar: false });
    };

    prepareQuoteRestRequest(prepareQuoteRest) {
        axios
            .get(prepareQuoteRest)
            .then(() => {
                // handle success
                console.log('success');
            })
            .catch(error => {
                console.log(error);
            });
    }

    getCSCID = () => {
        const queryString = this.state.config.linkToShare.split('?')[1];
        const queries = queryString ? queryString.split('&') : null;
        if (queries) {
            for (let i = 0; i < queries.length; i++) {
                const query = queries[i].split('=');
                if (query[0] === CSC_ID) {
                    return query[1];
                }
            }
        }
    };

    updateLinkToShare = () => {
        const CSCValue = this.getCSCID();
        return window.location.search
            ? `${window.location.href}&${CSC_ID}=${CSCValue}`
            : `${window.location.href}?${CSC_ID}=${CSCValue}`;
    };

    handleBtnClick = e => {
        e.preventDefault();
        let linkToShare;
        if (
            this.state.config.linkToShare &&
            this.state.config.linkToShare.split('?')[0] !==
                `${window.location.origin}+${window.location.pathname}`
        ) {
            linkToShare = this.updateLinkToShare();
        }

        this.setState(state =>
            linkToShare
                ? {
                      showTopBar: true,
                      config: {
                          ...state.config,
                          linkToShare,
                      },
                      isLinkUpdated: true,
                  }
                : {
                      showTopBar: true,
                      isLinkUpdated: true,
                  },
        );

        const { prepareQuoteRest } = this.state.config;

        if (prepareQuoteRest) {
            this.prepareQuoteRestRequest(prepareQuoteRest);
        }
    };

    handleHeaderChangeEvent = e => {
        const { stickyAreaHeight, headerHeight } = e.detail;
        this.stickyHeaderHeight = stickyAreaHeight || headerHeight;
        this.updateTopOffset();
    };

    watchSDLHeader = header => {
        const config = {
            attributes: true,
            attributeFilter: ['class'],
        };

        const callback = mutationList => {
            let isEvent = false;

            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationList) {
                if (
                    !isEvent &&
                    mutation.target.classList.contains('increased') &&
                    this.state.isDesktop
                ) {
                    isEvent = true;
                    this.sdlHeaderHeight = SDL_HEADER_DESKTOP_INCREASED;
                    this.updateTopOffset();
                } else if (
                    !isEvent &&
                    mutation.target.classList.contains('reduced') &&
                    this.state.isDesktop
                ) {
                    isEvent = true;
                    this.sdlHeaderHeight = SDL_HEADER_DESKTOP_REDUCED;
                    this.updateTopOffset();
                }
            }
            isEvent = false;
        };

        this.observer = new MutationObserver(callback);
        this.observer.observe(header, config);
    };

    updateTopOffset = () => {
        const comparisonDesktopHeader = document.querySelector(
            'div[class*=DesktopProducts_stickyBackground_]',
        );
        const comparisonMobileHeader = document.querySelector(
            'div[class*=MobileProducts_productCardsContainer_minified__]',
        );
        const pdpDesktopHeader = document.querySelector('.product-description-wrapper');

        let isStickyHeaderVisible = false;

        if (comparisonDesktopHeader) {
            isStickyHeaderVisible = comparisonDesktopHeader.className.includes(
                'DesktopProducts_stickyBackground_visible',
            );
        } else if (comparisonMobileHeader) {
            isStickyHeaderVisible = comparisonMobileHeader.className.includes(
                'MobileProducts_productCardsContainer_sticked',
            );
        } else if (pdpDesktopHeader) {
            isStickyHeaderVisible = pdpDesktopHeader.className.includes(
                'product-description-block__sticked',
            );
        }

        let offset = 0;
        if (isStickyHeaderVisible && this.stickyHeaderHeight) {
            offset = this.stickyHeaderHeight;
        } else if (this.sdlHeader) {
            offset = this.sdlHeaderHeight;
        }
        this.setState({ stickyAreaHeight: offset });
    };

    loadConfig() {
        axios
            .get(API_COPY_LINK_CONFIG_URL, {
                params: {
                    pushSite: window.apcSiteId || DEFAULT_SITE_ID,
                },
            })
            .then(({ data: config }) => {
                this.setState({
                    config,
                });
            })
            .catch(error => {
                console.error(error);
            });
    }

    componentDidMount() {
        document.body.addEventListener('PDP_HEADER_CHANGE', this.handleHeaderChangeEvent);
        document.body.addEventListener('COMPARISON_HEADER_CHANGE', this.handleHeaderChangeEvent);
        document.addEventListener('mousedown', this.handleClickOutside);
        this.sdlHeader = document.querySelector('.sdl-header-global');
        let stickyAreaHeight = this.sdlHeader.classList.contains('reduced')
            ? SDL_HEADER_DESKTOP_REDUCED
            : SDL_HEADER_DESKTOP_INCREASED;
        if (!isDesktop()) {
            stickyAreaHeight = SDL_HEADER_MOBILE;
        }

        if (stickyAreaHeight) {
            this.setState({ stickyAreaHeight });
        }

        if (this.sdlHeader) {
            this.watchSDLHeader(this.sdlHeader);
        }

        if (this.state.btnEnabled) {
            this.loadConfig();
        }

        const btn = document.getElementById(COPY_LINK_BTN);

        if (!btn) {
            return;
        }

        const clipboard = new ClipboardJS(`#${COPY_LINK_BTN}`);
    }

    componentWillUnmount() {
        document.body.removeEventListener('PDP_HEADER_CHANGE', this.handleHeaderChangeEvent);
        document.body.removeEventListener('COMPARISON_HEADER_CHANGE', this.handleHeaderChangeEvent);
        this.observer.disconnect();
        document.removeEventListener('mousedown', this.handleClickOutside);

        const btn = document.getElementById(COPY_LINK_BTN);

        if (!btn) {
            return;
        }

        const clipboard = new ClipboardJS(`#${COPY_LINK_BTN}`);
        clipboard.destroy();
    }

    componentDidUpdate() {
        if (this.state.isLinkUpdated) {
            const btn = document.getElementById(COPY_LINK_BTN);

            if (!btn) {
                return;
            }

            const clipboard = new ClipboardJS(`#${COPY_LINK_BTN}`);
            this.setState({
                isLinkUpdated: false,
            });
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setTopPositionBarRef(node) {
        this.topPositionBarRef = node;
    }

    handleClickOutside(event) {
        if (
            this.wrapperRef &&
            this.topPositionBarRef &&
            !this.wrapperRef.contains(event.target) &&
            !this.topPositionBarRef.contains(event.target)
        ) {
            this.setState({ showTopBar: false });
        }
    }

    render() {
        const { stickyAreaHeight, config } = this.state;
        const buttonWrapperClasses = classNames({
            [styles.copyLinkButtonWrapper]: true,
        });

        const copyLinkButtonClasses = classNames({
            [styles.copyLinkButton]: true,
        });

        if (!config.linkToShare) {
            return null;
        }

        const topBarConatinerStyle = {};

        if (stickyAreaHeight) {
            topBarConatinerStyle.top = `${stickyAreaHeight}px`;
        }

        if (config.noHeader) {
            topBarConatinerStyle.top = '0';
        }

        return (
            <div className={buttonWrapperClasses} {...this.props} ref={this.setWrapperRef}>
                <button
                    className={copyLinkButtonClasses}
                    aria-label=""
                    onClick={this.handleBtnClick}
                    data-clipboard-text={config.linkToShare}
                    data-clipboard-action="copy"
                    id="copyBtn"
                >
                    <IconCopy />
                </button>
                <div className={styles.tooltip}>Copy shared link to clipboard</div>

                <Portal into="body">
                    <div ref={this.setTopPositionBarRef}>
                        <TopPositionBar
                            handleCloseComparison={this.handleCloseTopBar}
                            hideTopBar={!this.state.showTopBar}
                            clipboardLink={config.linkToShare}
                            topBarConatinerStyle={topBarConatinerStyle}
                        />
                    </div>
                </Portal>
            </div>
        );
    }
}

export default CopyLinkButton;
